<template>
    <div v-if="!isGroupParticipant && !eventData.noInvoiceRecipient">
        <h2>{{ eventData.chargeable ? $t('eventRegistration.summary.invoiceRecipient') : $t('eventRegistration.summary.contactPerson') }}</h2>
        <div class="invoice-recipient-grid">
            <PersonCard
                :person-key="registrationData.invoiceReceivingPerson"
                :view-only="true"
                registering-person-type="invoiceRecipient" />
        </div>
    </div>
</template>

<script>
import PersonCard from "@/components/pages/registration/persons/PersonCard";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";

export default {
    name: "InvoiceRecipientViewOnly",
    components: {PersonCard},
    mixins: [mainRegistrationMixin, registrationGroupMixin]
}
</script>

<style lang="scss" scoped>

</style>
